import React from 'react';
import { ImpersonateStudent } from '@/components/staffer/ImpersonateStudent';
import cn from '@/utils/cn';
import useGradesTableStore from '../../store/useGradesTableStore';
import styles from '../styles.module.scss';
import { filterAssignmentsByType } from '../utils';
import StudentGradeCell from './StudentGradeCell';
import { IStudent } from '../../types';

interface StudentRowProps {
  student: IStudent
}

const StudentRow = ({ student }: StudentRowProps) => {
  const allAssignments = useGradesTableStore(state => state.assignments);
  const assignmentTypeFilter = useGradesTableStore(state => state.filters.assignmentType);
  const submissions = useGradesTableStore(state => state.submissions);
  const programId = useGradesTableStore(state => state.programId);
  const stafferId = useGradesTableStore(state => state.stafferId);
  const isImpersonating = useGradesTableStore(state => state.isImpersonating);
  const assignments = filterAssignmentsByType(allAssignments, assignmentTypeFilter);

  const renderGradeSpacer = () => {
    if (assignments.length < 1) {
      return Array.from({ length: 4 })
        .map((_, i) => (
          <td
            key={`spacer-${student.id}-${i}`}
            className={cn(styles.studentGradeCell, { [styles.lastCell]: i === 3 })}
          />
        ));
    }

    if (assignments.length < 3) {
      return Array.from({ length: 4 - assignments.length })
        .map((_, i) => (
          <td
            key={`spacer-${student.id}-${i}`}
            className={cn(styles.studentGradeCell, { [styles.lastCell]: i === assignments.length - 1 })}
          />
        ));
    }
  };

  return (
    <tr key={student.id} className={styles.studentRow}>
      <td className={`${styles.studentNameCell} tw-group`}>
        {student.first_name} {student.last_name}
        <span className="tw-absolute tw-right-0 tw-top-1/2 -tw-translate-y-1/2">
          <ImpersonateStudent
            buttonClass="tw-bg-transparent tw-rounded-full tw-border-none tw-cursor-pointer tw-hidden group-hover:tw-block"
            enabled={!isImpersonating}
            programId={programId}
            stafferId={stafferId}
            student={{ ...student, name: `${student.first_name} ${student.last_name}` }}
            wrapperClass=""
          />
        </span>
      </td>

      {assignments.map((assignment, i) => {
        const submission = submissions.find(s => (s.user_id === student.id && s.assignment_id === assignment.id));

        return (
          <StudentGradeCell
            key={`student-grade-cell-${student.id}-${assignment.id}`}
            assignment={assignment}
            lastCell={i === assignments.length - 1 && assignments.length > 2}
            student={student}
            submission={submission}
          />
        );
      })}
      {renderGradeSpacer()}
    </tr>
  );
};

export default StudentRow;
